// extracted by mini-css-extract-plugin
export var checkoutRateBadge = "_u7-0";
export var checkoutRateBadgeLink = "_u7-1";